// Parse only the initial model reasoning envelope, never a tag quoted in an answer.
// ``expected`` alone never hides text: a reply without envelope evidence is the
// reply itself, as built-in tool answers and interrupted turns have none.
export function splitThinking(raw = '', { expected = false, streaming = false } = {}) {
  const text = String(raw);
  const start = text.trimStart();
  const tagged = /^<(think|assessment)(?:>|\s)/i.test(start);
  const close = text.indexOf('</think>');
  if (close >= 0 && (expected || tagged)) return {
    reasoning: text.slice(0, close).replace(/^\s*<think>\s*/i, '').trim(),
    answer: text.slice(close + 8).replace(/^\s+/, '').replace(/<\/end>\s*$/, ''),
    pending: false,
  };
  const prefix = streaming && start && ['<think>', '<assessment>'].some(tag => tag.startsWith(start));
  if (tagged || prefix) return {
    reasoning: withoutPartialTag(text.replace(/^\s*<think>\s*/i, '')).trim(),
    answer: '', pending: streaming,
  };
  // The opening character is already fixed, so untagged text cannot still become
  // an envelope; only the pre-token state of an expected turn stays pending.
  if (expected && streaming && !start) return { reasoning: '', answer: '', pending: true };
  return { reasoning: '', answer: text, pending: false };
}

function withoutPartialTag(text) {
  for (const tag of ['<think>', '</think>', '<assessment>', '</assessment>']) {
    for (let n = tag.length - 1; n > 0; n--) {
      if (text.endsWith(tag.slice(0, n))) return text.slice(0, -n);
    }
  }
  return text;
}
